import { api } from "@/api/client";
import { convertToURLSearchParams } from "@/util";

export type ProcedureSearch = {
  standard?: string;
  recordType?: string;
  recordNumber?: string;
};

export type ProcedureSummary = {
  standard: string;
  recordId: string;
  recordType: string;
  recordNumber: string;
  company: string;
  division: string;
  processes: string;
  matProductForms: string;
};

export function getProcedures(filters: Partial<ProcedureSearch>) {
  const params = convertToURLSearchParams(filters);
  return api.get<ProcedureSummary[]>(`procedures?${params.toString()}`);
}
